// extracted by mini-css-extract-plugin
export default {"PropertyRating":"PropertyRating_PropertyRating__MWWVM"};